import { Routes } from '@angular/router';
import { NotFoundComponent } from './modules/admin/pages/not-found/not-found.component';

/**
 * Root routes of the application.
 *
 * Grafo de dependencias:
 *   AppModule -> AdminModule (lazy) -> SharedModule
 *
 * Los modulos de dominio se cargan bajo demanda con loadChildren.
 * Las rutas hijas de cada dominio se definen en su propio routing module.
 */
export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./modules/admin/admin.module').then(m => m.AdminModule),
  },
  {
    path: '',
    redirectTo: 'admin',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: NotFoundComponent,
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
